define("shared/utils/random-hex-color", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = randomHexColor;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  function randomHexColor() {
    return '#' + Math.floor(Math.random() * 0xffffff).toString(16).padStart(6, '0');
  }
});